<template>
  <div class="triage-desk-header">
    <!-- 第二导航栏 - 响应式部分 -->
    <nav class="triage-second-nav">
      <div :class="['second-nav-wrap', { 'mobile-second-nav': isMobile }]">
        <div class="logo">
          <a :href="siteJumpUrl" :title="$t('common.websiteName')">
            <img
              class="log-img"
              :data-not-lazy="true"
              v-lazy-load data-src="../../../../assets//web//images/common/logo.webp"
              :alt="$t('common.websiteName')"
              :height="!isMobile ? 23 : isMobile ? 29 : 29"
              :width="!isMobile ? 157 : isMobile ? 196 : 196"
            >
          </a>
        </div>

        <!-- 移动端菜单按钮 -->
        <span
          v-if="isMobile"
          class="iconfont menu-icon"
          :class="showSide ? 'iconcha' : 'iconshouqianniu'"
          @click="showHeaderSettings"
        />

        <!-- 右侧导航 - 共用但样式不同 -->
        <div class="second-nav-right">
          <div v-if="!isMobile" class="find-my-school-wrap">
            <div class="adress-wrap">
              <span class="iconfont icon-location" />
              <span class="find-school">{{ schoolName }}</span>
              <span class="iconfont icon-arrow-bottom-outline" />
              <div class="dropdown-list-wrapper">
                <ul class="dropdown-list">
                  <li
                    v-for="(item, index) in teachingPoinsList"
                    :key="item.name + index"
                    :class="['dropdown-item', {'is-select': item.name === schoolName}]"
                  >
                    <div
                      class="dropdown-item-link"
                      @click="toggleAdressDropdown(item)"
                    >
                      {{ item.name }}
                      <!-- <span v-if="item.distance" class="compuse-distance">{{ item.distance }}KM</span> -->
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div v-if="!isLogin" class="login-content">
            <div class="login-wrap" @click="handleLogin">
              <span class="iconfont icona-SignIn" />
              <span class="sign-in-text">{{ langContext.signIn }}</span>
            </div>
          </div>
          <div v-if="isLogin" class="logged-content" :class="{ 'logged-content-scrolled': !isMobile }">
            <div class="logged-in-wrap">
              <div class="user-avatar">
                <img
                  :data-not-lazy="true"
                  v-lazy-load :data-src="`${userInfo.parentAvatar}?im=Resize=(112,112)`"
                  :alt="userInfo.parentNickname"
                  width="26"
                  height="26"
                >
              </div>
              <div class="info-text text-overflow-ellipsis">
                {{ userInfo.parentNickname || $t("common.parent") }}
              </div>
              <span class="iconfont icon-arrow-bottom-outline" />
              <div class="dropdown-list-wrapper">
                <ul class="dropdown-list">
                  <li
                    v-for="(item, index) in userNavigationLinks"
                    :key="item.name + index"
                    class="dropdown-item"
                  >
                    <a
                      v-if="item.target && item.target === '_blank'"
                      class="dropdown-item-link"
                      :href="item.url"
                      target="_blank"
                    >{{ item.name }}</a>
                    <nuxt-link
                      v-else-if="item.url != ''"
                      class="dropdown-item-link"
                      :to="item.url"
                    >
                      {{ item.name }}
                    </nuxt-link>
                  </li>
                  <li class="dropdown-item">
                    <div
                      class="dropdown-item-link"
                      @click="handleLogout()"
                    >
                      {{ langContext.signOut }}
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>
    <transition name="dropdown">
      <div v-if="showSide && isMobile" ref="settingPopRef" class="settings-pop">
        <div class="menu-actions">
          <a v-if="!isLogin" class="evaluation-btn menu-btn-item" href="/evaluation">Evaluation Now</a>
          <div v-if="!isLogin" class="login-wrap menu-btn-item" @click="handleLogin">
            <!-- <span class="iconfont icona-blogtubiao-SignIn" /> -->
            <svg t="1752747231008" class="icona-blogtubiao-SignIn" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6912" width="24" height="24"><path d="M411.733333 530.346667c134.826667 0 244.053333-109.226667 244.053334-243.626667S546.133333 42.666667 411.733333 42.666667 167.68 151.893333 167.68 286.293333s109.226667 243.626667 244.053333 243.626667zM21.333333 871.68c0-161.28 130.986667-292.693333 292.266667-292.693333h194.986667c161.28 0 292.266667 130.986667 292.266666 292.693333 0 53.76-43.946667 97.706667-97.28 97.706667H118.613333C64.853333 969.386667 21.333333 925.44 21.333333 871.68zM818.773333 305.92c20.906667 0 37.546667 16.64 37.546667 37.546667v108.8h112.64c18.773333 2.133333 33.706667 17.92 33.706667 37.546666s-14.933333 35.413333-33.706667 37.546667H856.32v108.8c0 20.906667-16.64 37.546667-37.546667 37.546667s-37.546667-16.64-37.546666-37.546667v-108.8h-108.8c-20.906667 0-37.546667-16.64-37.546667-37.546667s16.64-37.546667 37.546667-37.546666h108.8V343.466667c0-20.906667 16.64-37.546667 37.546666-37.546667z" fill="#FFFFFF" p-id="6913" /></svg>
            <span class="sign-in-text">{{ langContext.signIn }}</span>
          </div>
          <div v-if="isLogin" class="my-courses-wrap menu-btn-item">
            <!-- <span class="iconfont icona-Mycourses icona-Mycourses2" /> -->
            <svg id="mx_n_1752809864284" t="1752809864283" class="icona-Mycourses2" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="7635" width="24" height="24"><path d="M536.32 813.226667s-2.133333-0.426667-5.973333-2.986667c-2.133333-2.56-2.56-4.266667-2.56-5.546667l-6.4-63.573333s0-4.266667 2.56-7.68l328.533333-402.773333c5.546667-6.826667 11.946667-9.813333 21.333333-11.093334h4.693334c6.826667 0 13.226667 2.133333 18.773333 6.826667l34.133333 28.16c7.68 6.4 11.093333 12.8 11.093334 20.48 1.28 10.666667-0.853333 18.346667-6.4 25.173333l-329.386667 404.053334c-2.986667 2.986667-4.693333 3.413333-5.973333 3.413333l-63.146667 6.4h-1.28v-0.853333z" fill="#ffffff" p-id="7636" /><path d="M855.466667 276.906667V113.493333c0-17.066667-6.4-34.133333-20.053334-46.506666-12.373333-12.373333-29.44-20.053333-46.506666-20.053334H147.626667c-37.546667 0-66.986667 29.44-66.986667 66.986667v797.44c0 37.546667 29.44 66.986667 66.986667 66.986667h640.853333c17.066667 0 34.133333-6.4 46.506667-20.053334 12.373333-12.373333 20.053333-29.44 20.053333-46.933333v-354.986667l-227.413333 277.333334c-2.986667 4.693333-9.386667 7.68-15.786667 7.68l-71.68 6.4c-24.746667 1.706667-46.933333-15.36-48.213333-40.533334l-6.4-71.68c0-6.4 1.706667-12.373333 4.693333-15.36l364.373333-442.453333 0.853334-0.853333zM223.146667 202.24h487.253333c18.773333 0 32.853333 15.36 32.853333 32.853333s-15.36 32.853333-32.853333 32.853334H223.146667c-12.373333 0-23.466667-6.4-31.146667-15.36a32.725333 32.725333 0 0 1 0-34.133334c7.68-11.093333 18.773333-17.066667 31.146667-15.36v-0.853333z m199.253333 576H223.146667c-17.066667-1.706667-31.146667-15.36-31.146667-32.853333s14.08-32.853333 31.146667-32.853334H422.4c17.066667 1.706667 31.146667 15.36 31.146667 32.853334 1.706667 17.066667-12.373333 31.146667-31.146667 32.853333z m-232.106667-203.946667c0-18.773333 15.36-32.853333 32.853334-32.853333h132.266666c17.066667 1.706667 31.146667 15.786667 31.146667 32.853333s-14.08 32.853333-31.146667 32.853334h-132.266666c-17.066667 0-32.853333-14.08-32.853334-32.853334z m32.853334-136.96c-12.373333 0-23.466667-6.4-31.146667-15.36a32.725333 32.725333 0 0 1 0-34.133333c6.4-11.093333 18.773333-17.066667 31.146667-15.36h398.506666c12.373333 0 23.466667 6.4 31.146667 15.36 6.4 11.093333 6.4 23.466667 0 34.133333a31.146667 31.146667 0 0 1-31.146667 15.36H223.146667z" fill="#ffffff" p-id="7637" /></svg>
            <a class="my-courses-text" href="/my-courses/list">My Courses</a>
          </div>
          <div v-if="isLogin" :class="['logged-in-wrap menu-btn-item', {'active': showLoggedInDropdown}]" @click="toggleLoggedInDropdown">
            <img
              :data-not-lazy="true"
              v-lazy-load :data-src="`${userInfo.parentAvatar}?im=Resize=(112,112)`"
              :alt="userInfo.parentNickname"
              width="26"
              height="26"
            >
            <div class="info-text text-overflow-ellipsis">
              {{ userInfo.parentNickname || $t("common.parent") }}
            </div>
            <span class="iconfont icon-arrow-bottom-outline" />
          </div>
        </div>
        <!-- 点击登录后的name下拉 -->
        <transition name="dropdown">
          <div v-if="showLoggedInDropdown && isLogin" class="dropdown-list-wrapper footer-dropdown">
            <ul class="dropdown-list">
              <li
                v-for="(item, index) in userNavigationLinks"
                :key="item.name + index"
                class="dropdown-item"
              >
                <a
                  v-if="item.target && item.target === '_blank'"
                  class="dropdown-item-link"
                  :href="item.url"
                  target="_blank"
                >{{ item.name }}</a>
                <nuxt-link
                  v-else-if="item.url != ''"
                  class="dropdown-item-link"
                  :to="item.url"
                >
                  {{ item.name }}
                </nuxt-link>
              </li>
              <li class="dropdown-item">
                <div
                  class="dropdown-item-link"
                  @click="handleLogout()"
                >
                  {{ langContext.signOut }}
                </div>
              </li>
            </ul>
          </div>
        </transition>
        <div class="footer">
          <div :class="['adress-wrap', {'active': showAdressDropdown}]" @click="toggleAdressDropdown">
            <span class="iconfont icona-Findmyschool" />
            <span class="find-school">{{ schoolName }}</span>
            <span class="iconfont icon-arrow-bottom-outline" />
          </div>
        </div>
        <transition name="dropdown">
          <div v-if="showAdressDropdown" class="dropdown-list-wrapper footer-dropdown find-my-school-dropdown">
            <ul class="dropdown-list">
              <li
                v-for="(item, index) in teachingPoinsList"
                :key="item.name + index"
                :class="['dropdown-item', {'is-select': item.name === schoolName}]"
              >
                <div
                  class="dropdown-item-link"
                  @click="toggleAdressDropdown(item)"
                >
                  {{ item.name }}
                </div>
              </li>
            </ul>
          </div>
        </transition>
      </div>
    </transition>
    <ConfirmDialog
      :show.sync="diaLogShow"
      :append-to-body="true"
      :show-header="false"
      :is-triage-desk="true"
      width="500px"
      :content="$t('featureComponents.page.triageDesk.switchToCupertinoQuestions', {campus: selectedTeachingPoint.name})"
      :main-btn-text="$t('featureComponents.page.triageDesk.confirm')"
      :sub-btn-text="$t('featureComponents.page.triageDesk.cancel')"
      @mainBtnClick="confirmChange"
    />
  </div>
</template>
<script>
import { removeCookies } from 'common/utils';
import { oneApi } from 'config/api';
import bus from 'common/bus';
import mixin from './mixin';
import ConfirmDialog from '@/components/web/common/ConfirmDialog/index.vue';

export default {
  components: {
    ConfirmDialog,
  },
  mixins: [mixin],
  data() {
    return {
      lastScrollTop: 0,
      isMobile: false,
      closeCeliing: false,
      showSide: false,
      activeDropdown: null,
      showAdressDropdown: false,
      showLoggedInDropdown: false,
      diaLogShow: false,
    }
  },
  mounted() {
    this.checkScreenSize();
    window.addEventListener('resize', this.checkScreenSize);

    if (this.isLogin) {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(this.showmap, this.error);
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkScreenSize);
  },
  methods: {
    checkScreenSize() {
      this.isMobile = window.innerWidth <= 768;
    },
    handleLogin() {
      bus.$emit('login', {
        triggerSource: 'header',
      });
    },
    toggleAdressDropdown(item) {
      if (item?.name) {
        this.selectedTeachingPoint = item;
        this.diaLogShow = true;
      }
      if (this.isMobile) {
        // 点击地址包裹时，显示地址下拉菜单，隐藏登录下拉菜单
        this.showAdressDropdown = !this.showAdressDropdown;
        this.showLoggedInDropdown = false;
      }
    },
    toggleLoggedInDropdown() {
      // 点击登录包裹时，显示登录下拉菜单，隐藏地址下拉菜单
      this.showLoggedInDropdown = !this.showLoggedInDropdown;
      this.showAdressDropdown = false;
    },
    confirmChange() {
      this.schoolName = this.selectedTeachingPoint.name;
      window.sessionStorage.setItem('triage-desk-venue-name', this.schoolName);
      bus.$emit('toggleAdressDropdown', this.schoolName);
      this.diaLogShow = false;
    },
    async handleLogout() {
      await this.$axios.post(
        oneApi.commonLogout,
        {},
        { rewritePostBody: true },
      );
      removeCookies('_official_token');
      this.$store.dispatch('ucenter/resetUserInfo');
      this.$store.commit('ucenter/SET_UNPAID_LIST', {});
      this.$store.commit('ucenter/SET_IS_LOGIN', false);
      this.$router.push(this.siteJumpUrl);
    },
    showHeaderSettings() {
      this.showSide = !this.showSide;
      if (this.showSide) {
        this.showOrHideContainer('none');
      } else {
        this.showOrHideContainer('block');
      }
    },
    closeCeliingAction() {
      this.closeCeliing = true;
    },
    showOrHideContainer(displayStyle) {
      this.$nextTick(() => {
        const { settingPopRef } = this.$refs;
        const { headerRef } = this.$refs;
        if (settingPopRef) {
          settingPopRef.style.display = this.showSide ? 'block' : 'none';
        }
        if (headerRef) {
          headerRef.style.minHeight = this.showSide ? '100vh' : '0';
        }
        const dom = document.querySelector('#triageDeskWrapper')
        if (this.showSide) {
          if (dom) {
            dom.style.display = 'none';
          }
        } else if (dom) {
          dom.style.display = 'block';
        }
        console.log(`settingPopRef 显示状态: ${this.showSide ? '显示' : '隐藏'}  displayStyle: ${displayStyle}`);
      });
    },
  },
}
</script>
<style lang="scss" scoped>
/* 第二导航栏 */

/* 基础样式 */
.triage-desk-header {
  position: relative;
  width: 100%;

  /* 吸顶组件 */
  .suction-top {
    position: absolute;
    top: -74px;
    width: 100%;

    &.mobile-suction-top {
      top: 0;
      position: relative;
    }
  }

  /* 第一导航栏 */
  .us-first-nav {
    width: 100%;
    background: #f0f0f0;

    .first-nav-wrap {
      width: 1252px;
      margin: 0 auto;
      height: 50px;
      display: flex;
      align-items: center;

      &.mobile-first-nav {
        width: 100%;
        height: 15.467vw;
      }
    }

    .nav-item {
      height: 100%;
      width: 225px;
      font-size: 16px;
      font-family: 'Roboto-Flex', sans-serif;
      font-weight: 600;
      color: #44454c;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;

      .first-nav-icon {
        width: 30px;
        height: 34px;
      }

      &.active {
        background: #e7e7e7;
      }
    }

    .nav-item-link {
      font-family: 'Roboto-Flex', sans-serif;
      margin-left: 17px;
      font-weight: 600;
      color: #44454c;
    }
  }

  /* 第二导航栏 */
  .triage-second-nav {
    position: sticky;
    top: 0;
    z-index: 1000;
    background: #fff;
    width: 100%;
    // border-bottom: 1px solid #FFCC7D;
    transition: all 0.5s ease;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);

    .second-nav-wrap {
      justify-content: space-between;
      width: 1252px;
      margin: 0 auto;
      height: 64px;
      display: flex;
      align-items: center;

      &.mobile-second-nav {
        width: 100%;
        padding: 0 6.933vw 0 4.8vw;
        height: 17.067vw;
        justify-content: space-between;
      }
    }

    .logo {
      flex-shrink: 0;
      margin-top: 13px;
      margin-bottom: auto;  /* 抵消flex居中的默认效果 */
      a {
        display: block;
      }

      .log-img {
        display: block;
        transition: all 0.5s ease;
      }
    }

    .menu-icon {
      font-size: 28px;
      color: #ff9f09;
      cursor: pointer;
    }

    /* 公共下拉菜单 */
    .dropdown-list-wrapper {
      display: none;
      position: absolute;
      left: 50%;
      transform: translateX(-50%) scaleY(0);
      opacity: 0;
      z-index: 99;
      transition: opacity 0.2s ease-out;

      .dropdown-list {
        position: relative;
        background: #fff;
        box-shadow: 0 2px 4px 0 #ffd997;
        border-radius: 0 0 5px 5px;
        z-index: 99;
        list-style: none !important;
        padding: 0;

        .dropdown-item {
          position: relative;
          padding: 0 66px;
          font-size: 16px;
          font-family: 'Roboto-Flex', sans-serif;
          font-weight: 500;
          color: #44454c;
          text-align: center;
          white-space: nowrap;
          margin-top: 5px;

          &:first-child {
            margin-top: 0;
          }

          &:hover {
            background: #fff5e3;
            color: #ff9f0a;

            .dropdown-item-link {
              color: #ff9f0a;
            }
          }

          &.is-select {
            background: #fff5e3;
            color: #ff9f0a;

            .dropdown-item-link {
              color: #ff9f0a;
            }
          }

          .dropdown-item-link {
            height: 54px;
            line-height: 54px;
            font-size: 16px;
            font-family: 'Roboto-Flex', sans-serif;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            font-weight: 500;
            color: #44454c;
          }

          .compuse-distance {
            margin-left: 100px;
          }
        }

        .dropdown-item-compuse {
          .dropdown-item-link {
            justify-content: space-between;
          }
        }
      }
    }

    /* 中间导航 - 桌面端 */
    .second-nav-mid {
      height: 100%;
      flex: 1;
      display: flex;
      align-items: center;
      margin-left: 33px;

      &.hidden {
        opacity: 0;
      }
    }

    .second-nav-item {
      position: relative;
      height: 100%;
      margin-left: 11px;
      font-size: 16px;
      font-family: 'Roboto-Flex', sans-serif;
      font-weight: 600;
      color: #44454c;
      cursor: pointer;
      display: flex;
      align-items: center;

      .second-nav-item-link {
        font-size: 16px;
        font-weight: 600;
        color: #44454c;
        padding: 9px 15px;
        border-radius: 45px;
      }

      &:first-child {
        margin-left: 0;
      }

      &:hover {
        .second-nav-item-link {
          background: #eee;
        }

        .dropdown-list-wrapper {
          display: block;
          top: 64px;
          transform: translateX(-50%);
          opacity: 1;
          transition: opacity 0.2s ease-in;
        }

        .icon-arrow-bottom-outline {
          transform: rotate(180deg);
          color: #ff9f0a;
        }
      }
    }

    /* 右侧导航 */
    .second-nav-right {
      display: flex;
      align-items: center;
      height: 100%;

      .find-my-school-wrap {
        position: relative;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;

        &:hover {
          .adress-wrap {
            background: #eee;

            .dropdown-list-wrapper {
              display: block;
              top: 46px;
              transform: translateX(-50%);
              opacity: 1;
              transition: opacity 0.2s ease-in;
            }

            .icon-arrow-bottom-outline {
              transform: rotate(180deg);
            }
          }
        }
      }

      .logged-content {
        position: relative;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-left: 1px;

        &:hover {
          .logged-in-wrap {
            background: #eee;

            .dropdown-list-wrapper {
              display: block;
              top: 50px;
              transform: translateX(-50%);
              opacity: 1;
              transition: opacity 0.2s ease-in;
            }

            .icon-arrow-bottom-outline {
              transform: rotate(180deg);
            }
          }
        }
      }

      .my-courses-content,
      .login-content {
        position: relative;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-left: 1px;

        &:hover {
          .my-courses-wrap {
            background: #eee;
          }

          .login-wrap {
            background: #eee;
          }
        }
      }

      .adress-wrap,
      .login-wrap,
      .my-courses-wrap,
      .logged-in-wrap {
        position: relative;
        display: flex;
        align-items: center;
        font-size: 16px;
        font-family: 'Roboto-Flex', sans-serif;
        font-weight: 600;
        color: #44454c;
        cursor: pointer;
      }

      .icon-arrow-bottom-outline {
        transition: transform 0.5s ease;
      }

      .adress-wrap {
        padding: 6px 16px;
        border-radius: 45px;

        .icona-Findmyschool {
          font-size: 23px;
        }
      }

      .login-wrap {
        padding: 6px 16px;
        border-radius: 45px;

        .icona-SignIn {
          font-size: 23px;
        }
      }

      .my-courses-wrap {
        padding: 6px 16px;
        border-radius: 45px;

        .icona-Mycourses1 {
          font-size: 23px;
        }
      }

      .logged-in-wrap {
        padding: 6px 16px;
        border-radius: 45px;

        .user-avatar {
          width: 26px;
          height: 26px;
        }
      }

      .my-courses-text {
        margin-left: 7px;
        // flex-shrink: 0;
        text-align: center;
        color: #44454c;
      }

      .info-text {
        margin: 0 7px;
        max-width: 100px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        // flex-shrink: 0;
        text-align: center;
      }

      .find-school {
        margin: 0 7px;
        // flex-shrink: 0;
        text-align: center;
      }

      .sign-in-text {
        margin-left: 7px;
        // flex-shrink: 0;
        text-align: center;
      }

      .evaluation-btn {
        margin-left: 16px;
        width: 172px;
        // padding: 0 12px;
        height: 100%;
        background: #fa6000;
        display: flex;
        align-items: center;
        justify-content: center;
        border: none;
        font-size: 16px;
        line-height: 27px;
        font-family: 'Roboto-Flex', sans-serif;
        font-weight: bold;
        color: #fff;
        text-align: center;
        cursor: pointer;
      }
    }
  }

  /* 移动端侧边菜单 */
  .settings-pop {
    width: 100%;
    position: relative;
    background: #fff;
    flex-direction: column;
    z-index: 2000;
    display: none;

    .icon-arrow-bottom-outline {
      transition: transform 0.5s ease;
    }

    .menu-actions {
      width: 100%;
      height: 19.733vw;
      background: #f0f0f0;
      display: flex;
      align-items: center;
      padding: 0 6.933vw;

      .menu-btn-item + .menu-btn-item {
        margin-left: 6.133vw;
      }

      .menu-btn-item {
        width: 40vw;
        height: 10.4vw;
        border-radius: 13.333vw;
        font-size: 4.267vw;
        font-family: Roboto-Flex;
        font-weight: bold;
        color: #fff;
        display: inline-flex;
        align-items: center;
        justify-content: center;

        a {
          color: #fff;
        }
      }

      .evaluation-btn {
        background: #f45d00;
      }

      .login-wrap {
        background: #36b8e0;

        .sign-in-text {
          margin-left: 2.667vw;
        }

        .icona-blogtubiao-SignIn {
          // font-size: 6.4vw;
          width: 6.933vw;
          height: 6.933vw;
        }
      }

      .my-courses-wrap {
        background: #ff9f0a;

        .icona-Mycourses2 {
          font-size: 6.933vw;
        }

        .my-courses-text {
          margin-left: 2.667vw;
        }
      }

      .logged-in-wrap {
        background: #f45d00;

        .user-avatar {
          width: 6.933vw;
          height: 6.933vw;
        }

        .info-text {
          margin: 0 2.667vw;
          width: 18.667vw;
          max-width: 18.667vw;
        }

        &.active {
          .icon-arrow-bottom-outline {
            transform: rotate(180deg);
          }
        }
      }
    }

    .second-nav-item {
      height: 18.667vw;
      display: flex;
      flex-direction: column;
      transition: height 0.3s ease;
      overflow: hidden;
      position: relative;

      .placehoder-box {
        position: absolute;
        width: 100%;
        height: 100%;
        padding: 0 6.933vw;
        pointer-events: none; /* 关键属性：让点击事件穿透 */
        .bottom-line {
          width: 100%;
          height: 100%;
          border-bottom: 0.267vw solid #bebebe;
        }
      }

      .second-nav-item-link {
        display: block;
        font-size: 4.267vw;
        font-family: Roboto-Flex;
        font-weight: bold;
        color: #fa9e00;
        flex: 1;
        height: 100%;
        line-height: 18.667vw;
      }

      .icon-arrow-bottom-outline {
        color: #ffa827;
      }

      .second-nav-item-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 18.667vw;
        padding: 0 6.933vw;
      }

      .dropdown-list-wrapper {
        max-height: 0;
        overflow: hidden;
      }

      .dropdown-list-wrapper.active {
        max-height: 266.667vw;
      }

      .dropdown-list {
        list-style: none;
        padding: 0;
        margin: 0;
      }

      .dropdown-item {
        margin-bottom: 0.8vw;
        height: 14.133vw;
        padding: 0 6.933vw;
      }

      // .dropdown-item:first-child {
      //   margin-top: 0;
      // }

      .dropdown-item:active {
        background: #fff5e3;
        color: #ff9f0a;

        .dropdown-item-link {
          color: #ff9f0a;
        }
      }

      .dropdown-item-link {
        height: 100%;
        display: block;
        line-height: 14.133vw;
        font-size: 4.267vw;
        font-family: Roboto-Flex;
        font-weight: 500;
        color: #44454c;
        text-decoration: none;
      }
    }

    .second-nav-item.active {
      height: auto;

      .icon-arrow-bottom-outline {
        transform: rotate(180deg);
      }
    }

    .footer {
      margin-top: 9.333vw;
      display: flex;
      align-items: center;
      padding: 0 6.933vw;

      .adress-wrap {
        padding: 0 2.933vw;
        width: 100%;
        height: 10.133vw;
        border-radius: 1.6vw;
        background: #f5f5f5;
        display: inline-flex;
        align-items: center;
        font-size: 4.267vw;
        font-family: Roboto-Flex;
        font-weight: 600;
        color: #44454c;

        .icona-Findmyschool {
          font-size: 5.867vw;
          font-weight: 500;
        }

        &.active {
          .icon-arrow-bottom-outline {
            transform: rotate(180deg);
          }
        }
      }

      .find-school {
        margin: 0 3.467vw;
        flex: 1;
      }
    }

    .footer-dropdown {
      margin-top: 1.333vw;
      width: 100%;

      .dropdown-list {
        list-style: none;
        padding: 0;

        .dropdown-item + .dropdown-item {
          margin-top: 1.333vw;
        }

        .dropdown-item {
          padding: 0 6.933vw;

          &.is-select {
            background: #fff5e3;

            .dropdown-item-link,
            .compuse-distance {
              color: #fa9e00;
            }
          }

          &.active {
            background: #fff5e3;
            color: #fa9e00;

            .dropdown-item-link,
            .compuse-distance {
              color: #fa9e00;
            }
          }
        }

        .dropdown-item-link {
          height: 14.4vw;
          line-height: 14.4vw;
          font-size: 4.267vw;
          font-family: Roboto-Flex;
          font-weight: 500;
          color: #44454c;
          display: flex;
          align-items: center;
          justify-content: space-between;
        }
      }

      .dropdown-item:active {
        background: #fff5e3;
        color: #fa9e00;

        .dropdown-item-link,
        .compuse-distance {
          color: #fa9e00;
        }
      }

      .dropdown-item-compuse {
        width: 100%;

        .compuse-distance {
          color: #44454c;
        }
      }
    }
  }

  /* 下拉动画 */
  .dropdown-enter-active,
  .dropdown-leave-active {
    transition: all 0.3s ease;
    overflow: hidden;
  }

  .dropdown-enter,
  .dropdown-leave-to {
    max-height: 0;
    opacity: 0;
    transform: translateY(-10px);
  }

  .dropdown-enter-to,
  .dropdown-leave {
    max-height: 500px;
    opacity: 1;
    transform: translateY(0);
  }
}

@media (min-width: 1280px) and (max-width: 1439px) {
  .triage-desk-header {
    width: 100%;
    max-width: 100%;
  }

  .triage-desk-header .triage-second-nav,
  .triage-desk-header .us-first-nav {
    width: 100%;
    max-width: 100%;
  }

  .triage-desk-header .triage-second-nav .second-nav-wrap,
  .triage-desk-header .us-first-nav .first-nav-wrap {
    width: 100%;
    padding-left: 66px;
  }

  .triage-desk-header .triage-second-nav .second-nav-mid {
    flex: 1;
    margin-left: 12px;
  }

  .triage-desk-header .triage-second-nav .second-nav-right .logged-content:hover .logged-in-wrap .dropdown-list-wrapper {
    left: auto;
    right: 0;
    transform: translateX(0);
  }
}

@media (min-width: 1440px) and (max-width: 1919px) {
  .triage-desk-header {
    width: 100%;
    max-width: 100%;
  }

  .triage-desk-header .triage-second-nav,
  .triage-desk-header .us-first-nav {
    width: 100%;
    max-width: 100%;
  }

  .triage-desk-header .triage-second-nav .second-nav-wrap,
  .triage-desk-header .us-first-nav .first-nav-wrap {
    width: 1264px;
    max-width: 1264px;
  }

  .triage-desk-header .triage-second-nav .second-nav-mid {
    flex: 1;
    margin-left: 33px;
  }
}

/* 响应式调整 */
@media (max-width: 768px) {
  .triage-desk-header {
    margin-top: 0;

    &.is-close {
      margin-top: 0;
    }

    .us-first-nav {
      position: relative;
      top: auto;

      .first-nav-wrap {
        display: flex;

        .nav-item {
          flex: 1;
          height: 15.467vw;
          font-size: 4.267vw;
          font-family: 'Roboto-Flex', sans-serif;
          font-weight: 600;
          color: #44454c;
          display: flex;
          align-items: center;
          justify-content: center;

          &.active {
            background: #e7e7e7;
          }

          .first-nav-icon {
            width: 9.333vw;
            height: 10.667vw;
          }
        }

        .nav-item-link {
          margin-left: 4vw;
        }
      }
    }

    .triage-second-nav {
      position: relative;

      .menu-icon {
        font-size: 5.867vw;
      }

      .second-nav-right {
        display: none;
      }

      .logo {
        margin: auto 0;
      }

      .logo .log-img {
        width: 51.733vw;
        height: 7.467vw;
      }
    }

    .triage-desk-header .triage-second-nav .second-nav-right .logged-content:hover .logged-in-wrap .dropdown-list-wrapper {
      left: auto;
      right: 0;
      transform: translateX(0);
    }
  }
}

@media (min-width: 769px) {
  .triage-desk-header {
    position: sticky;
    top: 0;
    z-index: 1000;

    &.is-close {
      margin-top: 50px;
    }

    .suction-top {
      position: absolute;
      top: -74px;
    }

    .us-first-nav {
      position: absolute;
      top: -50px;
    }
  }
}
</style>
